
import { IonPage, IonRouterOutlet } from '@ionic/vue';
import { defineComponent } from 'vue';
import AppTabs from '@components/app/AppTabs.vue';

export default defineComponent({
  name: 'AppView',
  components: { IonPage, IonRouterOutlet, AppTabs },
})
